import React from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { StringConstantsMixin, ProPageStrings } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    GIFT_FLOW: { ALLTRAILS_2020 }
  }
} = StringConstantsMixin;

const {
  formText: { termsLink, privacy }
} = ProPageStrings;

const MiniFooter = ({ languageRegionCode }) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.rightsReserved}>{ALLTRAILS_2020}</div>
        <div className={styles.links}>
          <a href={LanguageSupportUtil.wrapUrlSafe(`/privacy`, languageRegionCode)}>{privacy}</a>|
          <a href={LanguageSupportUtil.wrapUrlSafe(`/terms`, languageRegionCode)}>{termsLink}</a>
        </div>
      </div>
    </div>
  );
};

MiniFooter.propTypes = {
  languageRegionCode: string
};

MiniFooter.defaultProps = {
  languageRegionCode: 'en-US'
};

export default MiniFooter;
